import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { Collapse, Dropdown } from "react-bootstrap";
import { Trans } from "react-i18next";
import { useDispatch } from "react-redux";
import axios from "axios";
import { onUsersSiteSetting } from "../../redux/homeAction";

function Sidebar(props) {
  const dispatch = useDispatch();
  const [state, setState] = useState({});

  const toggleMenuState = (menuState) => {
    if (state[menuState]) {
      setState({ ...state, [menuState]: false });
    } else if (Object.keys(state).length === 0) {
      setState({ [menuState]: true });
    } else {
      Object.keys(state).forEach((i) => {
        setState((prevState) => ({ ...prevState, [i]: false }));
      });
      setState({ [menuState]: true });
    }
  };

  const onRouteChanged = () => {
    document.querySelector("#sidebar").classList.remove("active");
    Object.keys(state).forEach((i) => {
      setState((prevState) => ({ ...prevState, [i]: false }));
    });

    const dropdownPaths = [
      { path: "/apps", state: "appsMenuOpen" },
      { path: "/admin", state: "adminMenu" },
      { path: "/game", state: "gameMenu" },
      { path: "/user", state: "userMenu" },
      { path: "/agent", state: "agentMenu" },
      { path: "/challenge", state: "challengeMenu" },
      { path: "/transaction", state: "transactionMenu" },
      { path: "/basic-ui", state: "basicUiMenuOpen" },
      { path: "/form-elements", state: "formElementsMenuOpen" },
      { path: "/tables", state: "tablesMenuOpen" },
      { path: "/icons", state: "iconsMenuOpen" },
      { path: "/charts", state: "chartsMenuOpen" },
      { path: "/user-pages", state: "userPagesMenuOpen" },
      { path: "/error-pages", state: "errorPagesMenuOpen" },
      { path: "/Reports", state: "reportsMenu" }, // Added By Team
    ];

    dropdownPaths.forEach((obj) => {
      if (isPathActive(obj.path)) {
        setState((prevState) => ({ ...prevState, [obj.state]: true }));
      }
    });
  };

  const isPathActive = (path) => {
    return props.location.pathname.startsWith(path);
  };

  useEffect(() => {
    dispatch(onUsersSiteSetting());
  }, []);

  useEffect(() => {
    onRouteChanged();

    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector("body");
    document.querySelectorAll(".sidebar .nav-item").forEach((el) => {
      el.addEventListener("mouseover", function () {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.add("hover-open");
        }
      });
      el.addEventListener("mouseout", function () {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.remove("hover-open");
        }
      });
    });
  }, [props.location]);

  var appURL = process.env.PUBLIC_URL;
  var logo =
    appURL + "https://img.icons8.com/dotty/512/admin-settings-male.png";

  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
        {/* <a className="brand-logo" href="/dashboard">
          <img
            src={logo}
            alt="logo"
            style={{ height: "75px ", width: "70px " }}
          />
        </a> */}
        <div className="font-weight-bold">
          <h3>ADMIN PANEL</h3>
        </div>
      </div>
      <ul className="nav">
        <li className="nav-item profile">
          <div className="profile-desc">
            <div className="profile-pic">
              <div className="count-indicator">
                <img
                  className="img-xs rounded-circle "
                  src="https://cdn-icons-png.flaticon.com/512/2206/2206368.png"
                  alt="profile"
                />
                <span className="count bg-success"></span>
              </div>
              <div className="profile-name">
                <h5 className="mb-0 font-weight-normal">
                  <Trans>User: {props.usertype}</Trans>
                </h5>
              </div>
            </div>
          </div>
        </li>
        <li className="nav-item nav-category">
          <span className="nav-link">
            <Trans>Navigation</Trans>
          </span>
        </li>
        {props.dashboard && (
          <li
            className={
              isPathActive("/dashboard")
                ? "nav-item menu-items active"
                : "nav-item menu-items"
            }
          >
            <Link className="nav-link" to="/dashboard">
              <span className="menu-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                >
                  <path
                    d="M2.85471 2.83683C3.39903 2.29694 4.13229 2 4.89704 2.0045C6.09815 2 7.27226 2 8.38789 2H10.1603C11.6853 2.0045 12.9494 3.26874 12.9764 4.82542C13.0079 6.68354 13.0079 8.41119 12.9764 10.0983C12.9449 11.7135 11.6988 12.9463 10.0748 12.9643C9.19763 12.9778 8.31592 12.9823 7.4567 12.9823C4.96452 13.0047 2.22942 13.3197 2.01799 10.0129C2.02698 9.04556 2.01799 8.09175 2.01799 7.12895C2.07647 5.68925 1.6851 3.9301 2.85471 2.83683Z"
                    fill="#7D7D7D"
                  />
                  <path
                    d="M12.9744 20.0438C12.9744 20.9976 12.9699 21.9875 12.9789 22.9593C13.0239 24.588 11.6885 26.0187 10.0608 25.9917C8.71191 25.9603 7.2551 25.9962 5.88821 25.9872C4.81359 26.0367 3.61757 25.9783 2.85319 25.1459C2.1113 24.4575 1.94943 23.3732 2.01238 22.3834C2.00788 20.9031 2.00788 19.3734 2.02137 17.8662C2.02587 16.5794 2.89366 15.4591 4.13464 15.1307C5.2947 14.8967 6.37831 15.0587 7.68225 15.0092C8.43313 15.0092 9.17952 15.0092 9.93041 15.0137C13.0374 15.1757 13.0733 17.5647 12.9744 20.0438Z"
                    fill="#7D7D7D"
                  />
                  <path
                    d="M24.3969 16.6083C27.8429 20.0111 25.3589 26.0315 20.5037 25.9999C15.6801 26.027 13.1329 20.0156 16.6105 16.6174C18.6655 14.4737 22.3419 14.4511 24.3969 16.6083Z"
                    fill="#7D7D7D"
                  />
                  <path
                    d="M15.0169 10.0511C14.9944 8.21972 14.9944 6.53233 15.0169 4.89894C15.0124 3.31054 16.3 2.01462 17.8892 2.01012H17.9252C19.6495 1.99663 21.3693 1.99663 23.1701 2.01012C24.6603 1.98763 26.0019 3.34204 25.9839 4.83144C25.9929 5.83488 25.9839 6.82031 25.9839 7.81475C25.9343 9.25465 26.2945 11.041 25.142 12.13C23.9669 13.3584 22.0176 12.8949 20.4959 12.9894C19.6315 12.9894 18.7671 12.9849 17.9297 12.9714C16.327 12.9759 15.0214 11.6845 15.0169 10.0781C15.0169 10.0736 15.0169 10.0646 15.0169 10.0511Z"
                    fill="#7D7D7D"
                  />
                </svg>
              </span>
              <span className="menu-title">
                <Trans>Dashboard</Trans>
              </span>
            </Link>
          </li>
        )}
        {props.earnings && (
          <li
            className={
              isPathActive("/earinigs")
                ? "nav-item menu-items active"
                : "nav-item menu-items"
            }
          >
            <Link className="nav-link" to="/earinigs">
              <span className="menu-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                >
                  <path
                    d="M8.29822 12.3601H23.2672C23.6515 12.3591 24.0197 12.2057 24.291 11.9336C24.5623 11.6614 24.7146 11.2928 24.7144 10.9085V3.20153C24.7146 2.81727 24.5623 2.44864 24.291 2.17652C24.0197 1.9044 23.6515 1.75101 23.2672 1.75H8.29822C7.9135 1.75083 7.54478 1.90403 7.27275 2.17606C7.00071 2.4481 6.84751 2.81682 6.84668 3.20153V10.9085C6.84751 11.2932 7.00071 11.662 7.27274 11.934C7.54478 12.206 7.9135 12.3592 8.29822 12.3601ZM8.70863 5.12829C8.71249 4.77217 9.05045 4.63761 9.35665 4.71792C9.47225 4.71782 9.58662 4.69411 9.69274 4.64825C9.79886 4.60238 9.89449 4.53532 9.97377 4.45118C10.0531 4.36704 10.1143 4.26759 10.1538 4.15893C10.1933 4.05028 10.2101 3.9347 10.2034 3.81929C10.189 3.75568 10.1892 3.68967 10.2038 3.62613C10.2184 3.56258 10.2471 3.50313 10.2877 3.45214C10.3283 3.40114 10.3799 3.35992 10.4386 3.3315C10.4972 3.30309 10.5616 3.2882 10.6267 3.28794H20.9387C20.999 3.2881 21.0586 3.30087 21.1136 3.32542C21.1687 3.34998 21.218 3.38577 21.2584 3.43051C21.3038 3.48338 21.3366 3.54578 21.3546 3.61308C21.3725 3.68039 21.3751 3.75087 21.3621 3.8193C21.3546 3.93486 21.371 4.05073 21.4103 4.15968C21.4495 4.26864 21.5107 4.36836 21.5901 4.45264C21.6696 4.53692 21.7655 4.60396 21.8719 4.64959C21.9783 4.69522 22.093 4.71847 22.2088 4.71788C22.2783 4.68956 22.3536 4.67826 22.4283 4.68491C22.5031 4.69157 22.5752 4.716 22.6386 4.75615C22.702 4.79631 22.7549 4.85104 22.7928 4.91578C22.8308 4.98051 22.8527 5.05339 22.8568 5.12832V8.98178C22.8528 9.05672 22.8308 9.1296 22.7928 9.19434C22.7549 9.25908 22.702 9.31381 22.6386 9.35397C22.5752 9.39412 22.5031 9.41854 22.4283 9.42518C22.3536 9.43182 22.2783 9.4205 22.2088 9.39215C21.9821 9.39269 21.7648 9.48298 21.6045 9.64329C21.4442 9.80359 21.354 10.0209 21.3534 10.2476C21.3731 10.3132 21.3775 10.3825 21.3661 10.45C21.3547 10.5176 21.328 10.5816 21.2879 10.6372C21.2478 10.6928 21.1954 10.7383 21.1349 10.7704C21.0743 10.8025 21.0072 10.8202 20.9387 10.8221H10.6267C10.5658 10.8224 10.5054 10.8099 10.4496 10.7853C10.3937 10.7608 10.3437 10.7247 10.3027 10.6796C10.2543 10.6199 10.2205 10.5498 10.204 10.4748C10.1875 10.3998 10.1888 10.322 10.2077 10.2475C10.2081 10.0213 10.1188 9.80412 9.95919 9.64374C9.79961 9.48335 9.58288 9.39287 9.35663 9.39219C9.05687 9.47118 8.70669 9.33881 8.70864 8.98175L8.70863 5.12829Z"
                    fill="#7D7D7D"
                  />
                  <path
                    d="M11.0501 9.95802H20.5153C20.5778 9.59494 20.755 9.26145 21.0209 9.00644C21.2868 8.75143 21.6274 8.58832 21.9928 8.54103V5.5645C21.6275 5.51887 21.2866 5.35687 21.0205 5.10246C20.7544 4.84805 20.5773 4.51474 20.5153 4.15186H11.0501C10.9881 4.51474 10.811 4.84804 10.5449 5.10246C10.2788 5.35687 9.93793 5.51887 9.57263 5.5645V8.54103C9.938 8.58832 10.2786 8.75143 10.5445 9.00645C10.8104 9.26146 10.9876 9.59495 11.0501 9.95802ZM15.7805 4.61843C16.4157 4.62984 17.0203 4.89282 17.4618 5.34964C17.9032 5.80645 18.1453 6.41976 18.135 7.05492C18.1434 7.36944 18.0888 7.68246 17.9743 7.97551C17.8597 8.26855 17.6877 8.53568 17.4682 8.76113C17.2487 8.98657 16.9863 9.16576 16.6965 9.28811C16.4066 9.41047 16.0951 9.4735 15.7805 9.4735C15.4659 9.4735 15.1545 9.41045 14.8646 9.2881C14.5747 9.16574 14.3123 8.98655 14.0929 8.7611C13.8734 8.53565 13.7013 8.26852 13.5868 7.97547C13.4723 7.68242 13.4176 7.3694 13.4261 7.05488C13.4165 6.41994 13.6589 5.80707 14.1002 5.35042C14.5414 4.89378 15.1456 4.63058 15.7805 4.61843Z"
                    fill="#7D7D7D"
                  />
                  <path
                    d="M15.7805 8.62741C17.7496 8.56294 17.7492 5.54656 15.7805 5.48242C13.8113 5.54687 13.8119 8.56328 15.7805 8.62741Z"
                    fill="#7D7D7D"
                  />
                  <path
                    d="M24.7532 14.0404C24.4605 13.8344 24.1013 13.7455 23.7464 13.791C23.3914 13.8366 23.0663 14.0134 22.8351 14.2867L20.4591 16.8701C20.7669 17.3294 20.935 17.8681 20.9429 18.421C20.9672 19.0799 20.7295 19.7217 20.2818 20.2058C19.834 20.69 19.2128 20.9771 18.5539 21.0044C18.5197 21.0753 15.0477 20.3863 14.8835 20.3656C14.7729 20.3434 14.6754 20.2787 14.612 20.1853C14.5487 20.0919 14.5245 19.9774 14.5448 19.8664C14.5651 19.7554 14.6282 19.6568 14.7204 19.5918C14.8127 19.5268 14.9268 19.5007 15.0381 19.5191C16.0695 19.7079 18.3163 20.1231 18.3163 20.1231C20.2216 20.3842 20.7555 17.4016 18.9859 16.7837C17.2575 16.1888 14.3955 15.4395 12.994 14.3428C11.145 13.0339 9.23123 13.2326 7.53345 14.8828C8.20045 16.487 9.82468 21.2708 10.4625 22.9484C10.6466 23.1589 10.8943 23.4233 11.0816 23.632L14.9985 25.2596C15.418 25.4316 15.8738 25.4956 16.3244 25.4458C16.775 25.396 17.2059 25.234 17.5776 24.9745L19.1026 23.9463C21.7098 22.1212 23.838 19.6937 25.3062 16.8701C25.8111 15.9753 25.5729 14.5936 24.7532 14.0404Z"
                    fill="#7D7D7D"
                  />
                  <path
                    d="M9.52934 22.9097C9.10435 21.7092 7.64135 17.6548 7.20947 16.4512C6.95852 15.8066 6.78978 14.8819 6.05167 14.6368C5.85731 14.5597 5.64857 14.5256 5.43978 14.5367C5.231 14.5479 5.0271 14.6041 4.84209 14.7015L3.39488 15.423C3.01811 15.6118 2.72253 15.9307 2.56288 16.3207C2.40322 16.7107 2.39031 17.1454 2.52654 17.5442L5.31298 25.2943C5.38192 25.4883 5.49176 25.6652 5.63504 25.813C5.77832 25.9609 5.9517 26.0762 6.14343 26.1511C6.33516 26.2261 6.54077 26.259 6.74632 26.2476C6.95187 26.2361 7.15256 26.1806 7.3348 26.0849L8.782 25.3634C8.99358 25.2529 9.18105 25.1013 9.33346 24.9175C9.48587 24.7338 9.60019 24.5215 9.66975 24.2931C9.7393 24.0647 9.76271 23.8248 9.73861 23.5873C9.7145 23.3498 9.64336 23.1194 9.52934 22.9097Z"
                    fill="#7D7D7D"
                  />
                </svg>
              </span>
              <span className="menu-title">
                <Trans> Admin Earnings</Trans>
              </span>
            </Link>
          </li>
        )}
        {(props.allAdmins || props.newAdmin || props.sitesettings) && (
          <li
            className={
              isPathActive("/admin")
                ? "nav-item menu-items active"
                : "nav-item menu-items"
            }
          >
            <div
              className={
                state.adminMenu ? "nav-link menu-expanded" : "nav-link"
              }
              onClick={() => toggleMenuState("adminMenu")}
              data-toggle="collapse"
            >
              <span className="menu-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.5609 3.02516C15.5687 3.26496 16.5311 3.66451 17.4132 4.20761L19.2666 3.38445L21.451 5.56889L20.6281 7.4217C21.1714 8.30392 21.5709 9.2667 21.8107 10.2747L23.7017 11.0025V14.0917L23.0619 14.338C22.7029 13.9874 22.2126 13.7708 21.6731 13.7708H19.0782C19.1493 13.3736 19.1865 12.9647 19.1865 12.5471C19.1865 8.73738 16.098 5.64895 12.2883 5.64895C8.47853 5.64895 5.39011 8.73738 5.39011 12.5471C5.39011 16.2666 8.33405 19.298 12.0188 19.4396V19.9474C12.0188 20.564 12.2581 21.0882 12.653 21.5181V23.9604H10.7437L10.0157 22.069C9.00796 21.8292 8.04552 21.4297 7.16346 20.8866L5.31005 21.7098L3.12561 19.5254L3.94855 17.6725C3.40523 16.7903 3.00573 15.8274 2.76588 14.8195L0.875 14.0918V11.0025L2.7662 10.2746C3.00601 9.2668 3.40555 8.3042 3.94877 7.42214L3.12566 5.56895L5.31005 3.38445L7.16346 4.20761C8.04552 3.66451 9.00796 3.26496 10.0157 3.02516L10.7437 1.13379H13.8329L14.5609 3.02516ZM16.2937 16.8749V18.6102C16.2937 18.9782 16.5948 19.2792 16.9627 19.2792H23.0561C23.4241 19.2792 23.7251 18.9781 23.7251 18.6102V16.8749H16.2937ZM18.6979 22.5681C18.6979 23.2924 19.2851 23.8796 20.0094 23.8796C20.7338 23.8796 21.321 23.2924 21.321 22.5681C21.321 21.846 20.7361 21.2565 20.0094 21.2565C19.2828 21.2566 18.6979 21.846 18.6979 22.5681ZM26.4907 21.1431C26.8653 20.8356 27.125 20.4515 27.125 19.9474V17.4085C27.125 17.1146 26.8853 16.8749 26.5914 16.8749H24.6002V18.6102C24.6002 19.461 23.907 20.1542 23.0561 20.1542H16.9627C16.1119 20.1542 15.4187 19.4611 15.4187 18.6102V16.8749H13.4275C13.1336 16.8749 12.8939 17.1146 12.8939 17.4085V19.9474C12.8939 20.4515 13.1535 20.8356 13.5281 21.1431C14.5455 21.9781 16.5746 22.2108 17.8377 22.314C17.9636 21.2265 18.888 20.3816 20.0094 20.3816C21.1305 20.3816 22.0546 21.226 22.181 22.3129C23.4419 22.2095 25.475 21.9768 26.4907 21.1431ZM13.5281 22.1996V25.8244C13.5281 26.3972 13.9968 26.8659 14.5696 26.8659H25.4492C26.022 26.8659 26.4906 26.3972 26.4906 25.8244V22.1996C25.5552 22.7236 23.9237 23.0568 22.1032 23.1993C21.8322 24.099 20.9972 24.7546 20.0094 24.7546C19.0216 24.7546 18.1866 24.099 17.9156 23.1994C16.0952 23.0569 14.4638 22.7237 13.5281 22.1996ZM22.7876 15.9999V15.7603C22.7876 15.1473 22.2861 14.6458 21.6731 14.6458H18.3459C17.7329 14.6458 17.2313 15.1473 17.2313 15.7603V15.9999H18.218V15.7603C18.218 15.6919 18.2775 15.6324 18.3459 15.6324H21.6732C21.7416 15.6324 21.8011 15.6919 21.8011 15.7603V15.9999H22.7876ZM8.2827 11.7045C7.80943 12.1778 7.80938 12.9523 8.2827 13.4255L10.1755 15.3184C10.7106 15.8534 11.5177 16.0986 12.1211 15.4953L16.2941 11.3223C16.7674 10.849 16.7674 10.0745 16.2941 9.60127V9.60122C15.8208 9.12795 15.0463 9.12795 14.573 9.60122L11.2368 12.9375L10.0038 11.7044C9.53039 11.2311 8.75596 11.2312 8.2827 11.7045Z"
                    fill="#7D7D7D"
                  />
                </svg>
              </span>
              <span className="menu-title">
                <Trans>Admin Manager</Trans>
              </span>
            </div>
            <Collapse in={state.adminMenu}>
              <div>
                <ul className="nav flex-column sub-menu">
                  {props.allAdmins && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/admin/alladmins")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/admin/alladmins"
                      >
                        <Trans>All Admins</Trans>
                      </Link>
                    </li>
                  )}
                  {props.newAdmin && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/admin/addadmin")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/admin/addadmin"
                      >
                        <Trans>Add New Admin</Trans>
                      </Link>
                    </li>
                  )}
                  {props.allAdmins && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/admin/sitesettings")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/admin/sitesettings"
                      >
                        <Trans>Website Settings</Trans>
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        {(props.allUsers ||
          props.newUser ||
          props.pendingKyc ||
          props.completedKyc ||
          props.rejectKyc ||
          props.supportChat) && (
          <li
            className={
              isPathActive("/user")
                ? "nav-item menu-items active"
                : "nav-item menu-items"
            }
          >
            <div
              className={state.userMenu ? "nav-link menu-expanded" : "nav-link"}
              onClick={() => toggleMenuState("userMenu")}
              data-toggle="collapse"
            >
              <span className="menu-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.99195 13.8397C9.99195 16.0542 11.7854 17.8477 14 17.8477C16.2146 17.8477 18.008 16.0543 18.008 13.8397H9.99195ZM26.7853 11.0063H20.1199C19.8116 9.94872 19.2403 9.01379 18.4869 8.26856C19.3941 7.23847 20.7227 6.5885 22.2031 6.5885C24.637 6.5885 26.6605 8.34501 27.0755 10.6595C27.1081 10.8412 26.97 11.0063 26.7853 11.0063ZM27.125 13.8397V15.6159L24.95 16.453C24.6742 17.6119 24.2148 18.7187 23.5902 19.733L24.5369 21.8644L22.0248 24.3765L19.8941 23.4301C18.8797 24.0549 17.7724 24.5144 16.6132 24.7901L15.7763 26.9646H12.2238L11.3865 24.7897C10.2277 24.5139 9.12089 24.0544 8.10655 23.4298L5.97516 24.3765L3.46309 21.8645L4.40945 19.7337C3.78459 18.7193 3.32522 17.612 3.04937 16.4529L0.875 15.6159V13.8397H7.80445C7.80445 17.2616 10.578 20.0352 13.9999 20.0352C17.4219 20.0352 20.1955 17.2617 20.1955 13.8397H27.125ZM14.0001 1.18839C15.536 1.18839 16.7811 2.43351 16.7811 3.96936C16.7811 5.5052 15.536 6.75032 14.0001 6.75032C12.4642 6.75032 11.2191 5.5052 11.2191 3.96936C11.2191 2.43351 12.4642 1.18839 14.0001 1.18839ZM8.90887 12.2058L19.0912 12.2057C19.2964 12.2057 19.4498 12.0224 19.4136 11.8204C18.9479 9.22384 16.679 7.29725 14.0001 7.29725C11.2958 7.29725 9.04761 9.24889 8.58648 11.8204C8.55028 12.0224 8.70368 12.2058 8.90887 12.2058ZM5.79693 1.03564C7.17927 1.03564 8.29992 2.15625 8.29992 3.53864C8.29992 4.92097 7.17927 6.04163 5.79693 6.04163C4.41454 6.04163 3.29394 4.92097 3.29394 3.53864C3.29394 2.15625 4.41454 1.03564 5.79693 1.03564ZM1.21472 11.0063C1.03004 11.0063 0.891953 10.8412 0.924547 10.6594C1.33957 8.34496 3.36306 6.58845 5.79693 6.58845C7.27743 6.58845 8.60595 7.23841 9.51311 8.2685C8.75968 9.01373 8.18841 9.94867 7.88009 11.0062L1.21472 11.0063ZM22.2032 1.03564C23.5855 1.03564 24.7062 2.15625 24.7062 3.53864C24.7062 4.92097 23.5855 6.04163 22.2032 6.04163C20.8208 6.04163 19.7002 4.92097 19.7002 3.53864C19.7002 2.15625 20.8208 1.03564 22.2032 1.03564Z"
                    fill="#7D7D7D"
                  />
                </svg>
              </span>
              <span className="menu-title">
                <Trans>User Manager</Trans>
              </span>
            </div>
            <Collapse in={state.userMenu}>
              <div>
                <ul className="nav flex-column sub-menu">
                  {props.allUsers && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/user/allusers")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/user/allusers"
                      >
                        <Trans>View All Users</Trans>
                      </Link>
                    </li>
                  )}{" "}
                  {props.allUsers && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/user/user-fraud")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/user/user-fraud"
                      >
                        <Trans>All Fraud Users</Trans>
                      </Link>
                    </li>
                  )}
                  {props.newUser && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/user/adduser")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/user/adduser"
                      >
                        <Trans>Add New User</Trans>
                      </Link>
                    </li>
                  )}
                  {props.pendingKyc && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/user/UserKyc")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/user/UserKyc"
                      >
                        <Trans>Pending Kyc</Trans>
                      </Link>
                    </li>
                  )}
                  {props.completedKyc && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/user/kyc")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/user/kyc"
                      >
                        <Trans>Completed Kyc</Trans>
                      </Link>
                    </li>
                  )}
                  {props.rejectKyc && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/user/reject")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/user/reject"
                      >
                        <Trans>Reject Kyc</Trans>
                      </Link>
                    </li>
                  )}
                  {props.pushNotification && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/user/notification")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/user/notification"
                      >
                        <Trans>Notification</Trans>
                      </Link>
                    </li>
                  )}
                  {props.supportChat && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/user/chat")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/user/chat"
                      >
                        <Trans>Chat</Trans>
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        {(props.allChallenges ||
          props.completedChallenges ||
          props.conflictChallenges ||
          props.cancelledChallenges ||
          props.runningChallenges ||
          props.newChallenge) && (
          <li
            className={
              isPathActive("/challenge")
                ? "nav-item menu-items active"
                : "nav-item menu-items"
            }
          >
            <div
              className={
                state.challengeMenu ? "nav-link menu-expanded" : "nav-link"
              }
              onClick={() => toggleMenuState("challengeMenu")}
              data-toggle="collapse"
            >
              <span className="menu-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                >
                  <path
                    d="M27.2891 12.8578V25.2551H0.710938L27.2891 12.8578ZM19.3347 12.1184C20.6226 12.1184 21.6704 11.0706 21.6704 9.78269C21.6704 8.4948 20.6226 7.44699 19.3347 7.44699C18.0467 7.44699 16.999 8.4948 16.999 9.78269C16.999 11.0706 18.0467 12.1184 19.3347 12.1184ZM13.7377 8.03307L14.1401 7.06177L13.553 5.61058L15.1625 4.00096L16.6137 4.58814L17.5851 4.18575L18.1972 2.74463H20.4721L21.0842 4.18575L22.0556 4.58814L23.5068 4.00096L25.1164 5.61058L24.5292 7.06177L24.9316 8.03307L26.3728 8.64525V10.9201L24.9316 11.5323L24.5292 12.5036L24.7593 13.0724L17.9535 16.2469L17.5851 15.3796L16.6137 14.9772L15.1626 15.5643L13.553 13.9547L14.1401 12.5036L13.7377 11.5321L13.2379 11.3029C13.6341 10.9136 13.824 10.3258 13.7035 9.71214C13.5896 9.13218 13.2235 8.67598 12.7387 8.45739L13.7377 8.03302V8.03307ZM16.124 9.78269C16.124 11.5531 17.5643 12.9934 19.3347 12.9934C21.1051 12.9934 22.5454 11.5531 22.5454 9.78269C22.5454 8.01229 21.1051 6.57199 19.3347 6.57199C17.5643 6.57199 16.124 8.01229 16.124 9.78269ZM3.9305 22.7879L5.67842 18.0616L5.33105 17.951C4.64231 17.731 4.10085 17.2621 3.77305 16.6755L1.43052 23.954L3.9305 22.7879V22.7879ZM8.30725 9.1371C9.27434 9.1371 10.0611 8.23301 10.0611 7.12182C10.0611 6.01062 9.27434 5.10647 8.30725 5.10647C7.34016 5.10647 6.55337 6.01057 6.55337 7.12182C6.55337 8.23307 7.34016 9.1371 8.30725 9.1371ZM5.5965 17.1173L7.60955 17.758L6.36885 21.6505L8.97947 20.4328L9.80946 17.7887C9.93727 17.3845 9.91216 17.0005 9.73476 16.6472C9.55101 16.2784 9.25788 16.0272 8.86298 15.9007L4.66211 14.5641C4.61114 14.5479 4.55585 14.5526 4.50838 14.5773C4.46097 14.6019 4.42526 14.6444 4.40923 14.6954L4.38457 14.7737C4.07389 15.7533 4.61743 16.8045 5.5965 17.1172V17.1173ZM7.63087 14.5905L8.51452 11.8454L12.2888 10.8678C12.7572 10.7462 12.9231 10.2793 12.8448 9.88075C12.7548 9.42192 12.3957 9.1411 11.9707 9.19841L6.71606 9.90322C6.21512 9.97109 5.82411 10.2987 5.67022 10.7793L4.73419 13.6886C4.79954 13.6968 4.86413 13.7102 4.92718 13.7303L7.63082 14.5904L7.63087 14.5905Z"
                    fill="#7D7D7D"
                  />
                </svg>
              </span>
              <span className="menu-title">
                <Trans>Challenge Manager</Trans>
              </span>
            </div>
            <Collapse in={state.challengeMenu}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <Link to="/admin/tournaments">Ludo Tournaments</Link>
                  {props.allChallenges && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/challenge/allchallenges")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/challenge/allchallenges"
                      >
                        <Trans>View All Challenge</Trans>
                      </Link>
                    </li>
                  )}
                  {props.completedChallenges && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/challenge/completed_challange")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/challenge/completed_challange"
                      >
                        <Trans>Completed Challenge</Trans>
                      </Link>
                    </li>
                  )}
                  {props.conflictChallenges && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/challenge/conflict_challange")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/challenge/conflict_challange"
                      >
                        <Trans>Conflict Challenge</Trans>
                      </Link>
                    </li>
                  )}
                  {props.conflictChallenges && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/challenge/pending_challange")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/challenge/pending_challange"
                      >
                        <Trans>Pending Challenge</Trans>
                      </Link>
                    </li>
                  )}
                  {props.conflictChallenges && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/challenge/hours_challange")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/challenge/hours_challange"
                      >
                        <Trans>Hours Challenge</Trans>
                      </Link>
                    </li>
                  )}
                  {props.cancelledChallenges && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/challenge/cancelled_challange")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/challenge/cancelled_challange"
                      >
                        <Trans>Cancelled Challenge</Trans>
                      </Link>
                    </li>
                  )}
                  {props.runningChallenges && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/challenge/running_challange")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/challenge/running_challange"
                      >
                        <Trans>Running Challenge</Trans>
                      </Link>
                    </li>
                  )}
                  {props.newChallenge && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/challenge/new_challange")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/challenge/new_challange"
                      >
                        <Trans>New Challenge</Trans>
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        {(props.penalty ||
          props.bonus ||
          props.depositHistory ||
          props.withdrawlHistory ||
          props.allWithdrawlRequests ||
          props.allDepositRequests) && (
          <li
            className={
              isPathActive("/transaction")
                ? "nav-item menu-items active"
                : "nav-item menu-items"
            }
          >
            <div
              className={
                state.transactionMenu ? "nav-link menu-expanded" : "nav-link"
              }
              onClick={() => toggleMenuState("transactionMenu")}
              data-toggle="collapse"
            >
              <span className="menu-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                >
                  <path
                    d="M27.125 10.5002C27.1257 10.6154 27.1036 10.7295 27.0601 10.8362C27.0165 10.9428 26.9524 11.0397 26.8713 11.1215L21.6213 16.3715C21.5395 16.4526 21.4425 16.5167 21.3359 16.5603C21.2293 16.6038 21.1152 16.6259 21 16.6252C20.8863 16.6266 20.7733 16.6058 20.6675 16.564C20.5063 16.4978 20.3686 16.385 20.272 16.24C20.1753 16.095 20.1241 15.9245 20.125 15.7502V13.1252H12.25C12.018 13.1252 11.7954 13.033 11.6313 12.869C11.4672 12.7049 11.375 12.4823 11.375 12.2502V8.75024C11.375 8.51817 11.4672 8.29561 11.6313 8.13152C11.7954 7.96743 12.018 7.87524 12.25 7.87524H20.125V5.25024C20.1257 5.07719 20.1778 4.90824 20.2745 4.76475C20.3712 4.62127 20.5084 4.50969 20.6685 4.44413C20.8287 4.37857 21.0047 4.36197 21.1743 4.39643C21.3438 4.43089 21.4994 4.51487 21.6213 4.63774L26.8713 9.88774C27.0329 10.0507 27.124 10.2707 27.125 10.5002ZM15.75 14.8752H7.87502V12.2502C7.87415 12.0775 7.82218 11.9089 7.72563 11.7656C7.62909 11.6224 7.49231 11.5109 7.33251 11.4452C7.17317 11.3782 6.99754 11.3599 6.8278 11.3926C6.65806 11.4253 6.50181 11.5076 6.37876 11.629L1.12876 16.879C1.04767 16.9607 0.983509 17.0577 0.939965 17.1643C0.896421 17.2709 0.874349 17.3851 0.875015 17.5002C0.874349 17.6154 0.896421 17.7295 0.939965 17.8362C0.983509 17.9428 1.04767 18.0397 1.12876 18.1215L6.37876 23.3715C6.46052 23.4526 6.55749 23.5167 6.6641 23.5603C6.7707 23.6038 6.88486 23.6259 7.00001 23.6252C7.11479 23.6282 7.22867 23.6042 7.33251 23.5552C7.49231 23.4896 7.62909 23.3781 7.72563 23.2349C7.82218 23.0916 7.87415 22.923 7.87502 22.7502V20.1252H15.75C15.9821 20.1252 16.2046 20.0331 16.3687 19.869C16.5328 19.7049 16.625 19.4823 16.625 19.2502V15.7502C16.625 15.5182 16.5328 15.2956 16.3687 15.1315C16.2046 14.9674 15.9821 14.8752 15.75 14.8752Z"
                    fill="#7D7D7D"
                  />
                </svg>
              </span>
              <span className="menu-title">
                <Trans>Transaction Manager</Trans>
              </span>
            </div>
            <Collapse in={state.transactionMenu}>
              <div>
                <ul className="nav flex-column sub-menu">
                  {props.bonus && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/transaction/bonus")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/transaction/bonus"
                      >
                        <Trans>Bonus</Trans>
                      </Link>
                    </li>
                  )}
                  {props.penalty && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/transaction/penalty")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/transaction/penalty"
                      >
                        <Trans>Penalty</Trans>
                      </Link>
                    </li>
                  )}
                  {props.penalty && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/transaction/penalty")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/transaction/penalty-history"
                      >
                        <Trans>Penalty History</Trans>
                      </Link>
                    </li>
                  )}
                  {props.depositHistory && props.allAdmins && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/transaction/transaction_history")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/transaction/transaction_history"
                      >
                        <Trans>Deposit history</Trans>
                      </Link>
                    </li>
                  )}
                  {props.depositHistory && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive(
                            "/transaction/pending_transaction_history",
                          )
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/transaction/pending_transaction_history"
                      >
                        <Trans>Pending Deposit history</Trans>
                      </Link>
                    </li>
                  )}
                  {props.depositHistory && props.allAdmins && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/transaction/game-play-bonus-rewards")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/transaction/game-play-bonus-rewards"
                      >
                        <Trans>Game Play Rewards</Trans>
                      </Link>
                    </li>
                  )}
                  {props.depositHistory && props.allAdmins && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive(
                            "/transaction/convert_transaction_history",
                          )
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/transaction/convert_transaction_history"
                      >
                        <Trans>Convert Deposit history</Trans>
                      </Link>
                    </li>
                  )}
                  {props.bonusHistory && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/transaction/bonus_history")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/transaction/bonus_history"
                      >
                        <Trans>Bonus history</Trans>
                      </Link>
                    </li>
                  )}
                  {props.withdrawlHistory && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/transaction/withdraw")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/transaction/withdraw"
                      >
                        <Trans>Withdrawl history</Trans>
                      </Link>
                    </li>
                  )}
                  {props.allWithdrawlRequests && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/transaction/allwithdrawl")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/transaction/allwithdrawl"
                      >
                        <Trans>View All Withdrawl Request</Trans>
                      </Link>
                    </li>
                  )}
                  {props.allDepositRequests && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/user/generate-report")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/user/generate-report"
                      >
                        <Trans>Report Generate Users</Trans>
                      </Link>
                    </li>
                  )}
                  {props.allDepositRequests && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/transaction/alldeposits")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/transaction/alldeposits"
                      >
                        <Trans>View All Deposit Request</Trans>
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        {/* {props.pages &&
            <li className={isPathActive('/Pages') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
            <Link className="nav-link" to="/Pages">
              <span className="menu-icon"><i className="mdi mdi-speedometer"></i></span>
              <span className="menu-title"><Trans>Pages</Trans></span>
            </Link>
          </li>
          } */}
        {/* Added By Team */}
        {(props.bonusReport ||
          props.depositReport ||
          props.penaltyReport ||
          props.withdrawlReport) && (
          <li
            className={
              isPathActive("/reports")
                ? "nav-item menu-items active"
                : "nav-item menu-items"
            }
          >
            <div
              className={
                state.reportsMenu ? "nav-link menu-expanded" : "nav-link"
              }
              onClick={() => toggleMenuState("reportsMenu")}
              data-toggle="collapse"
            >
              <span className="menu-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                >
                  <path d="M17.5 0V7H24.5L17.5 0Z" fill="#7D7D7D" />
                  <path
                    d="M17.5 8.75C16.5358 8.75 15.75 7.96425 15.75 7V0H5.25C4.28575 0 3.5 0.78575 3.5 1.75V26.25C3.5 27.216 4.28575 28 5.25 28H22.75C23.716 28 24.5 27.216 24.5 26.25V8.75H17.5ZM10.5 24.5H7V19.25H10.5V24.5ZM15.75 24.5H12.25V15.75H15.75V24.5ZM21 24.5H17.5V12.25H21V24.5Z"
                    fill="#7D7D7D"
                  />
                </svg>
              </span>
              <span className="menu-title">
                <Trans>Reports</Trans>
              </span>
            </div>
            <Collapse in={state.reportsMenu}>
              <div>
                <ul className="nav flex-column sub-menu">
                  {props.bonusReport && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/Reports/bonus_report")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/Reports/bonusReport"
                      >
                        <Trans>bonus Report</Trans>
                      </Link>
                    </li>
                  )}
                  {props.depositReport && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/Reports/deposit_report")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/Reports/depositReport"
                      >
                        <Trans>deposit Report</Trans>
                      </Link>
                    </li>
                  )}
                  {props.penaltyReport && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/Reports/penalty_report")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/Reports/penaltyReport"
                      >
                        <Trans>penalty Report</Trans>
                      </Link>
                    </li>
                  )}
                  {props.withdrawalReport && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/Reports/withdrawal_report")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/Reports/withdrawalReport"
                      >
                        <Trans>withdrawal Report</Trans>
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
          </li>
        )}

        {/* Added By Team */}
        {(props.bonusReport ||
          props.depositReport ||
          props.penaltyReport ||
          props.withdrawlReport) && (
          <li
            className={
              isPathActive("/admin/support")
                ? "nav-item menu-items active"
                : "nav-item menu-items"
            }
          >
            <div
              className={
                state.chatSupport ? "nav-link menu-expanded" : "nav-link"
              }
              onClick={() => toggleMenuState("chatSupport")}
              data-toggle="collapse"
            >
              <span className="menu-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                >
                  <path
                    d="M4.5 15V12A9.5 9.5 0 0 1 23.5 12V15"
                    stroke="#7D7D7D"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                  />
                  <rect
                    x="3"
                    y="13"
                    width="5.8"
                    height="9"
                    rx="2.3"
                    fill="#7D7D7D"
                  />
                  <rect
                    x="19.2"
                    y="13"
                    width="5.8"
                    height="9"
                    rx="2.3"
                    fill="#7D7D7D"
                  />
                  <path
                    d="M22 22C22 24 19 25 16 25H14"
                    stroke="#7D7D7D"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <rect
                    x="11"
                    y="23.3"
                    width="5"
                    height="3"
                    rx="1.5"
                    fill="#7D7D7D"
                  />
                </svg>
              </span>

              <span className="menu-title">
                <Trans>Support</Trans>
              </span>
            </div>

            <Collapse in={state.chatSupport}>
              <div>
                <ul className="nav flex-column sub-menu">
                  {props.bonusReport && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          isPathActive("/admin/support")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/admin/support"
                      >
                        <Trans>Live Chat</Trans>
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
          </li>
        )}
      </ul>
    </nav>
  );
}

export default withRouter(Sidebar);
